export const INTERNAL_EMAIL_DOMAINS = ['mottmac.com', 'clientapp.moata.com', 'jnbentley.co.uk'] as const;

export const isInternalEmail = (email: string): boolean =>
  INTERNAL_EMAIL_DOMAINS.some((domain) => email?.split('@')?.[1] === domain);
